module.exports = __webpack_public_path__ + "img/brand_22.015353ed.png";